import { useCallback } from "react";
import { apiCreators } from "@/common/services";
import { usePaginatedFeed } from "@/common/hooks/usePaginatedFeed";

interface IProps {
  order: string;
  query?: string;
  verified?: boolean;
  tags?: string;
}

export const useSearchCreatorsPreviews = ({ order, query, verified, tags }: IProps) => {
  const request = useCallback((page?: number) => {
    return apiCreators.searchCreatorsPreviews({
      order,
      count: 30,
      query,
      tags,
      page: page || 1,
      verified,
    });
  }, [order, query, verified, tags]);

  const feed = usePaginatedFeed(["creatorsPreviewsGifs", order, query, verified, tags], request);

  return { feed };
};
